export const AG_CODE = "chem"

export const FG_PRODUCT_IDS = [7, 22, 3];

// Number() because product_id arrives as a string on some routes.
export const isFgProduct = (productId) =>
  FG_PRODUCT_IDS.includes(Number(productId));
